import React from "react";
import { useEffect, useState } from "react";
import { httpGet } from "../../../../../modules/Backend";
import { EntityNames } from "../../../../../enums/EntityNames";

interface ISidePanelDisposalYears {
    disposalId: string | undefined;
}

interface IYearSpan {
    start: number,
    end: number
}

export default function SidePanelDisposalYears({ disposalId }: ISidePanelDisposalYears) {
    const [yearSpans, setYearSpans] = useState<IYearSpan[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        async function getYears() {
            setLoading(true)
            const result = await httpGet(`api/${EntityNames.disposals}/getYears?disposalId=${disposalId}`)
            setYearSpans(result.data.yearSpans);
            setLoading(false);
        }
        if (disposalId) {
            getYears()
        }
    }, [disposalId])

    return (<>
        {loading &&
            <div className="side-panel__info-box margin__top--s">
                <div className={`display--flex alignItems--center flex__direction--column gap--s`}>
                    <div className={`form__wrapper form__wrapper`}>
                        <div className="loaders loaders__panel form__inline-loader"></div>
                    </div>
                </div>
            </div>
        }
        {!loading && yearSpans && yearSpans.length > 0 &&
            <div className="side-panel__info-box margin__top--s">
                <p className="xsmall">Disposal Contains Material From The Following Years</p>
                <div className="side-panel__info">
                    <div className="display--flex gap--s">
                        {yearSpans.map((yearSpan, colIdx) => (
                            <p className="small small--2">
                                {yearSpan.start === yearSpan.end ? yearSpan.start : `${yearSpan.start}-${yearSpan.end}`}
                            </p>
                        ))}
                    </div>
                </div>
            </div>
        }
    </>
    )
}